<div
  class="blur-overlay"
  [class.visible]="isPanelOpen"
  (click)="closePanel()"
></div>

<div class="notification-panel" [class.open]="isPanelOpen">
  <button class="btn close-btn" (click)="closePanel()">
    <i style="font-weight: 300; font-style: normal; transform: scaleX(1.3); display: inline-block;" class="fa-thin fa-x fa-lg"></i>
  </button>

  <h1>Notificaciones</h1>
  <div class="d-flex justify-content-between align-items-center mb-3">
    <span>12/04/2034</span>
    <span class="ms-3 ">Primera notificación</span>

  </div>

</div>
